import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';
import { AgeFilter } from 'types/enums';
import { ValueOf } from 'types/types';

type FilterValue = ValueOf<typeof AgeFilter>;

const AgeFilterData: Record<FilterValue, (value: number) => boolean> = {
  [AgeFilter.LOW]: (value: number) => value <= AgeFilter.LOW,
  [AgeFilter.MID]: (value: number) => value > AgeFilter.LOW && value <= AgeFilter.HIGHT,
  [AgeFilter.HIGHT]: (value: number) => value > AgeFilter.HIGHT,
};

const getFilterParams = () => ({
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.field || !filterItem.operator) {
      return null;
    }

    return (params: GridCellParams<unknown, number | string>) => {
      if (typeof params.value !== 'number') {
        return false;
      }

      return AgeFilterData[filterItem.operator as FilterValue](params.value);
    };
  },
  InputComponentProps: { type: 'number' },
});

export const getPatientAgeFilters = (): GridFilterOperator[] => {
  const lessThan55 = {
    label: `Less then ${AgeFilter.LOW}`,
    value: AgeFilter.LOW.toString(),
    ...getFilterParams(),
  };

  const from55to65 = {
    label: `From ${AgeFilter.LOW} to ${AgeFilter.HIGHT}`,
    value: AgeFilter.MID,
    ...getFilterParams(),
  };

  const moreThan65 = {
    label: `More then ${AgeFilter.HIGHT}`,
    value: AgeFilter.HIGHT.toString(),
    ...getFilterParams(),
  };

  return [lessThan55, from55to65, moreThan65];
};
